interface AddressDisplayProps {
  line1?: string | null;
  line2?: string | null;
  city?: string | null;
  state?: string | null;
  zip?: string | null;
  /** Compact mode (single line) */
  compact?: boolean;
  /** Show section header */
  showHeader?: boolean;
}

/**
 * Renders a physical address with consistent styling
 */
export const AddressDisplay = ({
  line1,
  line2,
  city,
  state,
  zip,
  compact = false,
  showHeader = true,
}: AddressDisplayProps) => {
  const hasAddress = line1 || city || state;
  if (!hasAddress) return null;

  if (compact) {
    // Compact: show one-line city, state
    return (
      <div className="text-sm text-gray-600">
        {[city, state, zip].filter(Boolean).join(', ')}
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {showHeader && (
        <div className="text-xs font-medium text-gray-500 uppercase tracking-wide">
          Address
        </div>
      )}
      <div className="text-sm text-gray-900 space-y-0.5">
        {line1 && <div>{line1}</div>}
        {line2 && <div>{line2}</div>}
        {(city || state) && (
          <div>{[city, state, zip].filter(Boolean).join(', ')}</div>
        )}
      </div>
    </div>
  );
};
